import type {CanvasDocumentsBlock} from '../types';
import {DocumentIcon} from '../../document-icon';
import {Icons} from '../../icons';
import {BlockLayout} from '../block-layout';
import {formatBytes} from '../../lib/utils';
import type {BlockRendererProps} from './types';

export const DocumentsBlock = ({
  block,
  actions,
}: BlockRendererProps<CanvasDocumentsBlock>) => {
  return (
    <BlockLayout title={block.title}>
      <div className="flex flex-col gap-1.5">
        {block.documents.map((doc) => (
          <div
            key={doc.id}
            className="flex items-center gap-3 rounded-lg border border-border bg-background px-4 py-3 shadow-xs transition-colors hover:border-(--canvas-primary)"
          >
            <DocumentIcon
              contentType={doc.contentType ?? undefined}
              name={doc.name}
            />
            <div className="min-w-0 flex-1">
              <span className="block truncate text-sm font-medium text-foreground">
                {doc.name}
              </span>
              {doc.byteSize != null && (
                <span className="text-xs text-muted-foreground">
                  {formatBytes(doc.byteSize)}
                </span>
              )}
            </div>
            {actions?.onDocumentDownload && (
              <button
                type="button"
                className="shrink-0 text-muted-foreground transition-colors hover:text-(--canvas-primary)"
                aria-label={`Download ${doc.name}`}
                onClick={() =>
                  actions.onDocumentDownload!({
                    blockId: block.id,
                    documentId: doc.id,
                    documentName: doc.name,
                  })
                }
              >
                <Icons.download className="size-4" />
              </button>
            )}
          </div>
        ))}
      </div>
    </BlockLayout>
  );
};

export const documentsBlockConfig = {
  component: DocumentsBlock,
  isEmpty: (block: CanvasDocumentsBlock) => block.documents.length === 0,
};
